var RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_PUBLIC_KEY || process.env.NEXT_PUBLIC_RECAPTCHA_PUBLIC_KEY;
var DEVICE_ID_KEY = 'paa_did';
var ALREADY_SUBSCRIBED_ERROR_MESSAGE = 'You already have a subscription.';
var STUDENT_VERIFICATION_ERROR_MESSAGE = 'Failed to verify your student status.';
var DEFAULT_ADD_PAYMENT_METHOD = 'This will be the default payment method for all future payments.';
var DEFAULT_ADD_PAYMENT_REFUSAL_MESSAGE = 'Something went wrong, please try again later.';
var DEFAULT_ERROR_MESSAGE = 'Something went wrong!';
var DEFAULT_REFUSAL_MESSAGE = 'Your payment failed, please try again.';
var RESEND_LIMIT_ERROR_CODE = 'ERR_0010:ERR_0051';
var numberRegexp = /^[0-9]+$/;
var MAX_SEATS_COUNT = 15;
var TIERS = ['plus', 'pro'];
var MAX_STARTER_TIER = 'max_starter';
var MAX_PERFORMANCE_TIER = 'max_performance';
var MAXIMIZER_TIERS = [MAX_STARTER_TIER, MAX_PERFORMANCE_TIER];
var subscriptionPyramid = ['free'].concat(TIERS, MAXIMIZER_TIERS);
var PRICING_CARDS_WITH_TEAM = ['pro', 'max_starter', 'max_performance', 'enterprise'];
var SUBSCRIPTION_TIERS_WITH_TEAM = ['pro'].concat(MAXIMIZER_TIERS);
var DEFAULT_SCOPE_ID = 'gold';
var DEFAULT_TEAM_SCOPE_ID = 'teams';
var DEFAULT_PLUS_TIER_SCOPE_ID = 'plus_web';
var DEFAULT_PRO_TIER_SCOPE_ID = 'pro_web';
var MAXIMIZER_STARTER_SCOPE_ID = 'max_starter_web';
var MAXIMIZER_PERFORMANCE_SCOPE_ID = 'max_performance_web';
var ADMIN_SCOPE_IDS = [DEFAULT_PRO_TIER_SCOPE_ID, MAXIMIZER_STARTER_SCOPE_ID, MAXIMIZER_PERFORMANCE_SCOPE_ID];
var DEFAULT_TIERS_SCOPE_IDS = [DEFAULT_PLUS_TIER_SCOPE_ID, DEFAULT_PRO_TIER_SCOPE_ID];
var MAXIMIZER_TIERS_SCOPE_IDS = [MAXIMIZER_STARTER_SCOPE_ID, MAXIMIZER_PERFORMANCE_SCOPE_ID];
var TIERS_SCOPE_IDS = [].concat(DEFAULT_TIERS_SCOPE_IDS, MAXIMIZER_TIERS_SCOPE_IDS);
var STORAGE_PREFIX = 'MONETIZATION_';
var TEAM_OPTIONS = [1, 3, 5, 10];
var STORE_URL = 'https://picsart.onelink.me/XqUB/l0v4c5j4';
var CREDITS_FAQ_ARTICLE_URL = 'https://support.picsart.com/hc/en-us/sections/19530880111261-Credits';
var CONTACT_US_BUSINESS_URL = 'https://sales.picsart.io/meetings/picsartdemo/book-a-demo';
var TEAMS_URL = '/gold/teams';
var SETTINGS_URL = '/settings?activeTab=BillingAndSubscriptions';
var PRICING_MARKETER_URL = '/pricing?tab=marketers';
var CREATE_URL = '/create';
var MAX_ESSENTIAL_PRODUCT_NAME = 'AdMaker Lite';
var MAX_PERFORMANCE_PRODUCT_NAME = 'AdMaker Max';
var PLANS_OPTIONS = ['makers', 'marketers'];
var TIER_NAMES = {
  max_performance: 'AdMaker Max',
  max_starter: 'AdMaker Lite',
  gold_old: 'Gold',
  free: 'Free',
  plus: 'Plus',
  pro: 'Pro'
};
var TIER_DEFAULT_SCOPE_ID_MAP = {
  max_performance: MAXIMIZER_PERFORMANCE_SCOPE_ID,
  max_starter: MAXIMIZER_STARTER_SCOPE_ID,
  gold_old: DEFAULT_SCOPE_ID,
  pro: DEFAULT_PRO_TIER_SCOPE_ID,
  plus: DEFAULT_PLUS_TIER_SCOPE_ID,
  free: ''
};
var PAYPAL_LOGO = 'https://cdn140.picsart.com/68977496610306108271.svg';
var GOLD_LOGO = 'https://cdn140.picsart.com/03383810557485452169.svg';
var PLUS_LOGO = 'https://pastatic.picsart.com/cms-pastatic/1e085e17-b46f-45e7-8e18-66b37592003b.svg';
var PRO_LOGO = 'https://pastatic.picsart.com/cms-pastatic/8c1fac8d-7b33-4027-a279-2dffe2e1a045.svg';
var REFERRAL_STICKER = 'https://cdn-cms-uploads.picsart.com/cms-uploads/a7c58dd6-5453-4dea-a7dd-7570cbdbbbe0.gif';
var entryPoints = {
  projectDuplication: 'projectDuplication'
};
var pinkConfettiJsonUrl = 'https://pastatic.picsart.com/cms-pastatic/a227d97d-f948-491b-b8ea-baea6fe73b9a.json';
var heartConfettiJsonUrl = 'https://cdn-cms-uploads.picsart.com/cms-uploads/2ab92c17-596a-4d77-83ec-ef7faa88a2d9.json';
var heartBouncingConfettiJsonUrl = 'https://cdn-cms-uploads.picsart.com/cms-uploads/e6d53f28-e823-4f17-a7a3-3c889cd2f53f.json';
var confettiJsonUrl = 'https://cdn140.picsart.com/63123555735291033930.json';
var fallingConfettiJsonUrl = 'https://pastatic.picsart.com/cms-pastatic/e98127d2-362f-4e6f-82a1-538866f1e21b.json';
var coinsConfettiJsonUrl = 'https://pastatic.picsart.com/cms-pastatic/13f0c324-1aa5-46c7-bf28-13780f7f0f16.json';
var coinsAnimation = 'https://pastatic.picsart.com/cms-pastatic/9941577c-9d0b-4e37-864f-101923c1cfdf.json';
var GIFT_VALENTINE_URL = '/pricing/special-offer/gift/valentine';
var PENDING_GENERATION_URL = '/guard/feature/pending-uses';
var COMMIT_GENERATION_URL = '/guard/feature/pending-uses/commit';
var ROLLBACK_GENERATION_URL = '/guard/feature/pending-uses/rollback';
var PENDING_CREDIT_URL = '/guard/credits/pending-uses';
var COMMIT_CREDIT_URL = '/guard/credits/pending-uses/commit';
var ROLLBACK_CREDIT_URL = '/guard/credits/pending-uses/rollback';
var AVAILABLE_USES_URL = '/guard/feature/available-uses';
var GTM_VALUES = {
  STORAGE_UPGRADE_ACTION_BUTTON: 'profile_storage_upgrade',
  UPGRADE_ACTION_BUTTON: 'profile_upgrade'
};
var GTM_CREATE_SOURCE = 'create';
var GTM_EDITOR_SOURCE = 'editor';

// fetch from back-end
var tierCreditsMap = {
  free: 20,
  plus: 200,
  pro: 500,
  gold_old: 500,
  max_starter: 5000,
  max_performance: 15000
};
var samsungEntrypoints = ['samsung', 'samsung-special'];
var PROMO_BANNER_ENTRY_POINT = 'promo_banner';

export { ADMIN_SCOPE_IDS, ALREADY_SUBSCRIBED_ERROR_MESSAGE, AVAILABLE_USES_URL, COMMIT_CREDIT_URL, COMMIT_GENERATION_URL, CONTACT_US_BUSINESS_URL, CREATE_URL, CREDITS_FAQ_ARTICLE_URL, DEFAULT_ADD_PAYMENT_METHOD, DEFAULT_ADD_PAYMENT_REFUSAL_MESSAGE, DEFAULT_ERROR_MESSAGE, DEFAULT_PLUS_TIER_SCOPE_ID, DEFAULT_PRO_TIER_SCOPE_ID, DEFAULT_REFUSAL_MESSAGE, DEFAULT_SCOPE_ID, DEFAULT_TEAM_SCOPE_ID, DEFAULT_TIERS_SCOPE_IDS, DEVICE_ID_KEY, GIFT_VALENTINE_URL, GOLD_LOGO, GTM_CREATE_SOURCE, GTM_EDITOR_SOURCE, GTM_VALUES, MAXIMIZER_PERFORMANCE_SCOPE_ID, MAXIMIZER_STARTER_SCOPE_ID, MAXIMIZER_TIERS, MAXIMIZER_TIERS_SCOPE_IDS, MAX_ESSENTIAL_PRODUCT_NAME, MAX_PERFORMANCE_PRODUCT_NAME, MAX_PERFORMANCE_TIER, MAX_SEATS_COUNT, MAX_STARTER_TIER, PAYPAL_LOGO, PENDING_CREDIT_URL, PENDING_GENERATION_URL, PLANS_OPTIONS, PLUS_LOGO, PRICING_CARDS_WITH_TEAM, PRICING_MARKETER_URL, PROMO_BANNER_ENTRY_POINT, PRO_LOGO, RECAPTCHA_SITE_KEY, REFERRAL_STICKER, RESEND_LIMIT_ERROR_CODE, ROLLBACK_CREDIT_URL, ROLLBACK_GENERATION_URL, SETTINGS_URL, STORAGE_PREFIX, STORE_URL, STUDENT_VERIFICATION_ERROR_MESSAGE, SUBSCRIPTION_TIERS_WITH_TEAM, TEAMS_URL, TEAM_OPTIONS, TIERS, TIERS_SCOPE_IDS, TIER_DEFAULT_SCOPE_ID_MAP, TIER_NAMES, coinsAnimation, coinsConfettiJsonUrl, confettiJsonUrl, entryPoints, fallingConfettiJsonUrl, heartBouncingConfettiJsonUrl, heartConfettiJsonUrl, numberRegexp, pinkConfettiJsonUrl, samsungEntrypoints, subscriptionPyramid, tierCreditsMap };
//# sourceMappingURL=index.js.map
